import request from "@/axios";

/** 标签渠道分页的接口 */
export const getChannelList = params => {
  return request({
    url: "/lebo-security/risk/labelChannel/page",
    method: "get",
    params
  });
};

/** 新增标签渠道的接口 */
export const addChannel = data => {
  return request({
    url: "/lebo-security/risk/labelChannel/save",
    method: "post",
    data
  });
};

/** 编辑标签页渠道的接口 */
export const editChannel = data => {
  return request({
    url: "/lebo-security/risk/labelChannel/update",
    method: "post",
    data
  });
};

/** 删除标签页渠道的接口 */
export const deleteChannel = id => {
  return request({
    url: `/lebo-security/risk/labelChannel/delById?id=${id}`,
    method: "get",
  });
};
